import constantType from "../../actions/constant/constantType";

const initialState = {
  constants: [],
  expirationDate: 0,
  loading: false,
  error: false,
  errorMessage: "",
};

const constantReducer = (state = initialState, action) => {
  switch (action.type) {
    case constantType.START_FETCHING_CONSTANT:
      return {
        ...state,
        constants: [],
        loading: true,
        error: false,
        expirationDate: action.expirationDate,
      };
    case constantType.SUCCESS_FETCHIED_CONSTANT:
      return {
        ...state,
        loading: false,
        constants: action.payload,
        error: false,
      };
    case constantType.FAILURE_FETCHED_CONSTANT:
      return {
        ...state,
        loading: false,
        constants: [],
        error: true,
        errorMessage: action.errorMessage,
        expirationDate: 0,
      };

    default:
      return state;
  }
};

export default constantReducer;
